import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Text, Pressable } from 'react-native';
import { UPDATE_TITLE_LOG } from './queries';
import Autocomplete from '../Autocomplete';
import { TITLE_LOG_STATUSES } from '.';
import NewAttachment from '../Attachments/new';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { elRed } from 'app/src/styles/colors';
import { Link } from 'app/src/utils/routing';
import EditLinkedAttachment from '../Attachments/LinkedAttachments/edit';
import { numberWithDelimiter } from 'app/src/utils/stringHelpers';
import { Warning, WarningText } from 'app/src/styles';

const EditTitleLog = ({setShowModal, refetch, knownTitleLog, assetId,
  assetMiles
}) => {
  const [submitting, setSubmitting] = useState();
  const [titleLog, setTitleLog] = useState(knownTitleLog);
  const [assets, setAssets] = useState();
  const [updateTitleLog] = useMutation(UPDATE_TITLE_LOG, {
    onCompleted: () => {
      if(refetch) {
//        refetch();
      }
      setShowModal(false);
    }
  });
  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if(input['linkedAttachment']) {
      input['linkedAttachmentAttributes'] = input['linkedAttachment'];
    }
    updateTitleLog({ variables: input });
  });

  const { control, handleSubmit, getValues, setValue, watch, formState: { errors } } = useForm({
    defaultValues: {
      id: titleLog.id,
      status: titleLog.status || '',
      titleNumber: titleLog.titleNumber || '',
      state: titleLog.state || '',
      trackingNumber: titleLog.trackingNumber || '',
      trackingShipper: titleLog.trackingShipper || '',
      sendTrackingEmail: false,
      notes: titleLog.notes || '',
      linkedAttachment: titleLog.linkedAttachment || null
    }
  });
  const [showFileInput, setShowFileInput] = useState(getValues('upload'));

  const onRemove = () => {
    setValue('upload', 'removed')
    setShowFileInput('removed');
  }

  let uploadValue = getValues('upload')

  const watchStatus = watch('status');
  const watchTrackingNumber = watch('trackingNumber');

  const canSendTrackingEmail = watchTrackingNumber && 'Release' === watchStatus;

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          { titleLog.asset?.id || assetId ?
            <></>
            :
            <Autocomplete
              label={'Asset'}
              placeHolder={''}
              resource={'Asset'}
              options={assets}
              setValue={setValue}
              name='assetId'
            />
          }
          <Input.Picker
            label="Status:"
            name="status"
            options={
              TITLE_LOG_STATUSES.map(tls => { return { value: tls, label: tls }})
            }
            control={control}
            errors={errors}
          />
          {'Release' == watchStatus && titleLog.asset?.titleReleaseWarning && (
            <Warning>
              <WarningText>
                WARNING: {titleLog.asset.titleReleaseWarning}
              </WarningText>
            </Warning>
          )}
          <Input.Text
            label="Title Number:"
            name="titleNumber"
            control={control}
            errors={errors}
          />
          <Input.StatePicker
            label="State:"
            name="state"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Shipping Company:"
            name="trackingShipper"
            options={
              ['Fedex', 'UPS', 'USPS'].map(shipper => (
                { value: shipper, label: shipper }
              ))
            }
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Tracking Number:"
            name="trackingNumber"
            control={control}
            errors={errors}
          />
          {canSendTrackingEmail && (
            titleLog.asset?.buyer?.email ? (
              <Input.Checkbox
                label={`Email Tracking Number to Buyer (${titleLog.asset.buyer.email})?`}
                name="sendTrackingEmail"
                control={control}
                errors={errors}
              />
            ) : (
              <Text>No buyer email. Cannot send tracking number</Text>
            )
          )}
          <View>
            <Text>
              <b>Odometer:</b>
              {assetMiles && assetMiles > 0 ?
                numberWithDelimiter(assetMiles) :
                ' No Mileage Entered'
              }
            </Text>
            <br />
          </View>
          <Input.Text
            label="Notes:"
            name="notes"
            control={control}
            errors={errors}
          />
          {titleLog.upload &&
            <View
              style={{
                marginTop: '5px',
                marginBottom: '10px'
              }
            }>
              <Text style={{fontSize: '16px', marginBottom: '10px'}}>
                Title Log File:
              </Text>
              <Link to={titleLog.upload.url} target="_blank">
                <Text>{titleLog.upload?.filename}</Text>
              </Link>
            </View>
          }
          {titleLog.linkedAttachment &&
            <EditLinkedAttachment
              linkedAttachment={titleLog.linkedAttachment}
              resourceId={titleLog.linkedAttachment.resourceId}
              resourceType={titleLog.linkedAttachment.resourceType}
              attachmentType={titleLog.linkedAttachment.attachmentType}
              setValue={setValue}
            />
          }
          {/* {!showFileInput || showFileInput === 'removed' ?
            <NewAttachment
              recordId={getValues('assetId')}
              recordType='Title Log'
              attachmentType='Title Log'
              refetch={refetch}
              name='upload'
              setValue={setValue}
            /> :
            <View
              style={{
                marginTop: '5px',
                marginBottom: '10px'
              }
            }>
              <Text style={{fontSize: '16px', marginBottom: '10px'}}>
                Title Log File:
              </Text>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row'
                }}
              >
                <Text>{titleLog.upload.filename}</Text>
                <Pressable
                  style={{
                    zIndex: 9999999,
                  }}
                  onPress={() => {
                    if(window.confirm('Remove Title Log File?')) {
                      onRemove();
                    }
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSquareXmark}
                    size='xl'
                    style={{color: elRed, marginLeft: '15px'}}
                    // onClick={() => setShowModal(false)}
                  />
                </Pressable>
              </View>
            </View>
          } */}
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Title Log" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditTitleLog;
